import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys.js'
import CacheManager from '../../../cache/CacheManager.js'
import PledgeAgreementGeneralTermsPageUI from './PledgeAgreementGeneralTermsPageUI.js'

class PledgeAgreementGeneralTermsPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      loan: null,
      template: null
    }
  }

  render() {
    return (
      <PledgeAgreementGeneralTermsPageUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.state.loan}
        template={this.state.template}
        onRefreshClick={this.onRefreshClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getLoan(context)
    this.getTemplates(context)
  }

  getLoan(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}`,
      cacheKey: CacheKeys.Loan(this.props.match.params.loanId),
      callback: this.getLoanCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getLoanCallback = (response) => {
    this.setState({ errorList: response.errorList, loan: response.loan })
  }

  getTemplates(context) {
    let templateCode = 'pledge_agreement_general'
    let cacheManager = new CacheManager({
      resource: `/api/su/loans/${this.props.match.params.loanId}/templates/${templateCode}`,
      cacheKey: CacheKeys.Templates(this.props.match.params.loanId, templateCode),
      callback: this.getTemplatesCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getTemplatesCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      template: response.template
    })
  }

  onRefreshClick = (noBusy) => {
    let context = this.props.context
    let templateCode = 'pledge_agreement_general'
    CacheManager.removeObject(CacheKeys.Loan(this.props.match.params.loanId))
    CacheManager.removeObject(CacheKeys.Templates(this.props.match.params.loanId, templateCode))
    if (noBusy === 'noBusy') {
      this.getLoan(context)
    } else {
      this.setState({
        template: null,
        errorList: null,
      })
      this.getLoan(context)
      this.getTemplates(context)
    }
  }
}

export default withRouter(PledgeAgreementGeneralTermsPageSF)
